import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {

    constructor(
        private router: Router,
        private messageService: NzMessageService,
        private readonly injector: Injector
    ) {
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

        return next.handle(request).pipe(
            catchError((res, caught) => {
                if (res instanceof HttpErrorResponse) {
                    if (res.status == 400) {
                        let message = res.error.message || res.error || res.statusText;
                        const code: string = JSON.parse(res.error?.errors?.Name[0] || "{}")?.Code;
                        if (/\/scada\/scadarest\//.test(request.url) && code) {
                            message = code;
                            // switch (code) {
                            //     case ('3004'):
                            //         this.messageService.error('Server 名称重复！');
                            //         break;
                            //     case ('3005'):
                            //         this.messageService.error('组名称重复！');
                            //         break;
                            //     case ('3010'):
                            //         this.messageService.error('设备名不能重复');
                            //         break;
                            //     case ('6001'):
                            //         this.messageService.error('名称已存在！');
                            //         break;
                            //     case ('9001'):
                            //         this.messageService.error('脚本名称重复');
                            //         break;
                            //     default:
                            //         this.messageService.error(`错误Code${ code }不存在`);
                            // }
                        } 
                        try {
                            const translateService = this.injector.get(TranslateService)
                            let errorMsg = translateService.instant(`ErrorInterceptor.${message}`)
                            errorMsg = translateService.instant(errorMsg.replace(/LoginFailed[0-9]*/g, 'LoginFailed')); // sdk登录失败code不在中英文包时，替换成LoginFailed
                            if (errorMsg.includes("ErrorInterceptor.")) {  // errorMsg不在中英文包时，去掉前缀ErrorInterceptor.
                                errorMsg = errorMsg.replace(/ErrorInterceptor./g, '')
                            }

                            // 
                            this.messageService.error(errorMsg);
                        } catch {
                            // log without translation translation service is not yet available
                        }
                    } else if (res.status === 404) {
                        this.messageService.error(`Api 404 occurs when ${request.method} ${request.url}`);
                    } else if (res.status === 405) {
                        this.messageService.error(`Api 405 occurs when ${request.method} method is not allowed.`);
                    } else if (res.status === 500) {
                        this.messageService.error(`Api 500 occurs detail ${res.message}`);
                        console.error(res.error);
                    }
                }
                return throwError(res);
            })
        );
    }
}
